import { Dialog } from "construct-ui";
import FileUploadInputComponent from "../../../../components/file/file-upload-input.component";
import { FILE_EXTENSIONS } from "../../../../config/constants";
import GSBNMappingModel from "../../../../models/gsbn-mapping-management/gsbn-mapping-management.model";
import ViewBase from "../../../view-base.view";

/**
 * GSBN Mapping Management - Excel Upload Dialog
 * 
 * The upload dialog used to download excel template and upload excel file
 * 
 * @author cmcnkhiep
 */

export default function GSBNMappingUploadDialog() {
    ViewBase.call(this);

    const FORM_ID = 'GSBNMappinggExcelUploadForm';
    const UPLOAD_INPUT_ID = 'GSBNMappinggExcelUploadInput';

    let file = null;
    let resultTableData = []
    let fileGuid = ''
    let isResultDownloaded = true;
    let onClose = () => { }

    const handleCloseDialog = () => {
        onClose();
        file = null;
        resultTableData = [];
        fileGuid = '';
    }

    const handleCloseDialogButtonClick = () => {
        if (!isResultDownloaded) {
            this.showConfirm(this.getText("EM00000794", "Are you sure you want to close this dialog without downloading the uploaded results?"), this.getText("LT00000999", "Close Dialog"), (e) => {
                if (e == "YES") {
                    isResultDownloaded = true;
                    handleCloseDialog();
                }
            });
        } else {
            handleCloseDialog();
        }
    }

    const downloadGSBNMappingExcelTemplate = () => {
        this.showLoading();
        GSBNMappingModel.downloadExcelTemplate()
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading();
            });
    };

    const upload = (e) => {
        // Form validation
        if (!this.validateForm(e)) {
            file = null;
            return false;
        }

        this.showLoading();
        GSBNMappingModel.uploadExcel(file)
            .then((result) => {
                if (result.data.length === 0) {
                    this.showErrorMessage(this.getText("EM00000141", "No records found."));
                    return
                }
                resultTableData = result.data;
                fileGuid = result.fileGuid;
                if (result.fileGuid.length) {
                    isResultDownloaded = false;
                }
                this.showMessage(this.getText('EM00000313', 'Upload Completed'), this.getText('LT00000475', 'Success'))
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading();
            });
    }

    const downloadUploadResult = () => {
        GSBNMappingModel.downloadUploadResult(fileGuid)
    }

    return {
        oninit: (vnode) => {
            onClose = vnode.attrs.onClose;
        },
        view: ({ attrs: { isOpen } }) => {
            return m(Dialog,
                {
                    isOpen,
                    onClose: handleCloseDialogButtonClick,
                    class: 'cui-dialog-xxl',
                    title: this.getText('LT00001001', 'Upload GSBN Mapping'),
                    closeOnOutsideClick: false,
                    content: [
                        m('.card.mb-3',
                            m('.card-body',
                                m('form.position-relative.needs-validation[novalidate]', { id: FORM_ID, onsubmit: upload },
                                    m('.row.gap-3',
                                        m('.col-12.position-relative',
                                            m(FileUploadInputComponent, {
                                                id: UPLOAD_INPUT_ID,
                                                accept: FILE_EXTENSIONS.XLSX,
                                                required: true,
                                                onTemplateDownloadClick: downloadGSBNMappingExcelTemplate,
                                                onInput: (data) => { file = data; },
                                            })
                                        ),
                                        m('.col-12.d-flex.justify-content-end',
                                            m('button.btn.btn-primary', { type: 'submit', form: FORM_ID, disabled: !!!file }, this.getText("LT00000290", "Upload"))
                                        )
                                    )
                                )
                            )
                        ),
                        m('.card',
                            m('.card-body',
                                m('.row.gap-3',
                                    m('.col-12.d-flex.justify-content-end',
                                        m('button.btn.btn-primary',
                                            {
                                                disabled: resultTableData.length === 0,
                                                onclick: () => {
                                                    isResultDownloaded = true;
                                                    downloadUploadResult();
                                                }
                                            },
                                            m('i.bi.bi-file-earmark-arrow-down-fill'),
                                            this.getText('LT00001002', 'Download Result')
                                        )
                                    ),
                                    m('.col-12',
                                        m('.table-responsive',
                                            m('table.table.table-hover',
                                                m('thead',
                                                    m('tr.align-middle',
                                                        m('th[scope="col"]', this.getText('LT00000723', 'Site Code')),
                                                        m('th[scope="col"]', this.getText('LT00000993', 'Sold To Code')),
                                                        m('th[scope="col"]', this.getText('LT00000994', 'Sold To Name'),),
                                                        m('th[scope="col"]', this.getText('LT00000995', 'Ship To Code'),),
                                                        m('th[scope="col"]', this.getText('LT00000996', 'Ship To Name'),),
                                                        m('th[scope="col"]', this.getText('LT00000092', 'Action')),
                                                        m('th[scope="col"]', this.getText('LT00000152', 'Remarks'))
                                                    )
                                                ),
                                                m('tbody',
                                                    (resultTableData.length == 0) &&
                                                    m('tr.align-middle',
                                                        m('td[colSpan=13]', this.getText("EM00000141", "No records found."))
                                                    ),
                                                    resultTableData.length > 0 &&
                                                    resultTableData.map((data, index) =>
                                                        m('tr.align-middle',
                                                            m('td', m('span.cursor-text', data.siteCode)),
                                                            m('td', m('span.cursor-text', data.soldToCode)),
                                                            m('td', m('span.cursor-text', data.soldToName)),
                                                            m('td', m('span.cursor-text', data.shipToCode)),
                                                            m('td', m('span.cursor-text', data.shipToName)),
                                                            m('td', m('span.cursor-text', data.action)),
                                                            m('td', m('span.cursor-text', data.remarks))
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    ),
                                )
                            )
                        ),
                        this.getBaseViews()
                    ],
                    footer: [
                        m('.d-flex.justify-content-end',
                            m('button.btn.btn-white', {
                                onclick: handleCloseDialogButtonClick,
                            }, this.getText('LT00000021', 'Close')),
                        )
                    ]
                }
            );
        }
    }
}
